// A19.06 legal holds / data-preservation — module-local data layer. REAL backend
// (/admin/legal-holds). A subject under an active hold must not be erased.
import { api } from '@/lib/api'

export interface LegalHold {
  id: number
  subject: string
  reason: string
  authority: string
  case_ref: string
  status: string // active|released
  expires_at: string | null
  released_at: string | null
  created_at: string
}

export const fetchHolds = (status = '', s?: AbortSignal) =>
  api.get<{ holds: LegalHold[] }>('/admin/legal-holds', { query: status ? { status } : {}, ...(s ? { signal: s } : {}) }).then((d) => d.holds ?? [])
export const createHold = (body: {
  subject_user_id?: number
  subject_ref: string
  reason: string
  authority: string
  case_ref: string
  expires_at?: string
}) => api.post<{ id: number }>('/admin/legal-holds', body)
export const releaseHold = (id: number) => api.post(`/admin/legal-holds/${id}/release`, {})
export const deleteHold = (id: number) => api.del(`/admin/legal-holds/${id}`)

export const AUTHORITIES = [
  { key: 'court', label: 'Суд' },
  { key: 'regulator', label: 'Регулятор' },
  { key: 'law_enforcement', label: 'Правоохранит.' },
  { key: 'internal', label: 'Внутренний' },
] as const

export function authLabel(a: string) {
  return AUTHORITIES.find((x) => x.key === a)?.label ?? a
}

export const LH_STR = {
  title: 'Legal hold / сохранение данных',
  desc: 'Запрет на удаление данных субъекта (суд/регулятор). GDPR-удаление проверяет активные holds',
  create: 'Новый hold',
  subjectUser: 'ID пользователя (опц.)',
  subjectRef: 'Email/телефон субъекта',
  reason: 'Причина',
  authority: 'Орган',
  caseRef: 'Номер дела',
  expires: 'Истекает (опц.)',
  add: 'Поставить hold',
  release: 'Снять',
  delete: 'Удалить',
  active: 'Активен',
  released: 'Снят',
  done: 'Готово',
  failed: 'Ошибка',
  empty: 'Нет holds',
  all: 'Все',
  subject: 'Субъект',
  case: 'Дело',
} as const
